const TYPE = 'messageEvents';

const messageEvents = {
  name: TYPE,
  state: null,
  effects: () => ({
    onMessage() {},
  }),
};

export default messageEvents;
